<template>
	<el-container id="pedidosproductos">
		<el-row type="flex" justify="center">
			<el-col :xs="24" :sm="23" :md="22" :lg="21" :xl="18" v-if="!this.$route.path.slice(13)">
				<filtros v-if="!this.responsive.isMobile" />
				<el-button-group v-if="!this.$route.path.slice(13) && !this.responsive.isMobile">
					<el-button
						type="text"
						style="padding-right: 10px;"
						size="mini"
						@click="
							visibleTable = true;
							fast = false;
						"
						><i class="el-icon-linear-menu2"></i
					></el-button>
					<el-button
						type="text"
						size="mini"
						@click="
							visibleTable = false;
							fast = false;
						"
						><i class="el-icon-linear-icons2"></i
					></el-button>
					<el-button style="padding-left: 5px;" type="text" size="mini" @click="fastLoad()"><i class="el-icon-linear-grid"></i></el-button>
				</el-button-group>
				<el-col
					v-if="!fast"
					:span="!this.responsive.isMobile ? 20 : 24"
					:class="{ productos: true, grid: !visibleTable, row: visibleTable }"
					v-loading="loadingproducto"
					element-loading-text="Cargando..."
				>
					<el-alert
						v-if="!loadingproducto && productos.length === 0"
						title="No se encontraron productos"
						description="Pruebe otros criterios de búsqueda"
						type="warning"
						center
						:closable="false"
						show-icon
					>
					</el-alert>
					<el-card
						v-else
						v-for="producto in productos"
						:key="producto.id"
						class="producto"
						shadow="hover"
						@click.native="redirect(producto.id, producto)"
					>
						<el-image class="pic" :src="imageSrcProd(producto)" fit="contain">
							<div slot="placeholder" class="pic slot">
								Cargando...
							</div>
							<div slot="error" class="pic slot">SIN FOTO</div>
						</el-image>
						<div :class="responsive.isMobile ? 'contentMobile' : 'content'">

							<b>{{ producto.nombre }}</b>
	
							<p>
								<small v-if="producto.bonificacion_uno !== '0.00' || producto.bonificacion_dos !== '0.00'" style="text-decoration: line-through; font-size: 12px; color: #888; margin-left: 8px;">
									{{ producto.precio_lista_con_formato }}
								</small>
								<br/>
								{{ producto.precio_final_con_formato }}
								por
								{{ producto.unimed_venta_completa | singular }}
								<el-badge v-if="producto.es_nuevo" value="Nuevo" class="badge" />
								<el-badge v-if="producto.es_promocion" value="Promo" class="badge" />
								<b style="color: #00a650; font-size: 13px; display: block;">
									{{ producto.bonificacion_uno !== '0.00' ? producto.bonificacion_uno_con_formato : '' }}
									{{ producto.bonificacion_uno !== '0.00' && producto.bonificacion_dos !== '0.00' ? ' + ' : '' }}
									{{ producto.bonificacion_dos !== '0.00' ? producto.bonificacion_dos_con_formato : '' }}
									{{ producto.bonificacion_uno !== '0.00' || producto.bonificacion_dos !== '0.00' ? ' OFF ' : '' }}
								</b>
							</p>
							<!-- <div>
								{{ 'Articulo: ' + producto.articulo }}
							</div> -->
							<div>
								{{ 'Codigo alfanumérico: ' + producto.codigo_alfanumerico }}
							</div>
							<div v-if="producto.factor_venta !== '1.000000'">
								{{
									'Cantidad por ' +
									producto.unimed_venta_completa +
									': ' +
									producto.cantidad_envase_con_formato +
									' ' +
									producto.unidad_medida_completa
								}}
							</div>
						</div>
					</el-card>
				</el-col>
				<el-col v-if="fast" :span="!this.responsive.isMobile ? 20 : 24">
					<fast></fast>
				</el-col>
			</el-col>
		</el-row>
		<el-row class="el-row is-justify-center el-row--flex" v-if="!this.$route.path.slice(13) && !fast">
			<!-- <el-col :xs="4" :sm="23" :md="22" :lg="21" :xl="18" /> -->
			<el-col :xs="21" :sm="21" :md="12" :lg="12" :xl="12">
				<el-pagination
					layout="prev, pager, next"
					hide-on-single-page
					:page-size="this.limit"
					:total="this.total"
					@current-change="changepage"
					style="margin-top: 10px;"
				/>
			</el-col>
		</el-row>
	</el-container>
</template>
<script>
import filtros from '@/components/Filtros.vue';
import fast from '@/views/pedidos/PedidosFast.vue';
// import Producto from '@/models/Producto';
export default {
	name: 'productos',
	inject: ['responsive'],
	components: {
		filtros,
		fast,
	},
	data() {
		return {
			filter: {
				patron: '',
				familia_id: '',
				subfamilia_id: '',
				unidad: '',
				presentacion_id: '',
				rubro_id: '',
				subrubro_id: '',
				linea_id: '',
				marca_id: '',
				es_nuevo: false,
				es_promocion: false,
			},
			loadingSelect: false,
			start: 0,
			limit: 12,
			page: 1,
			visibleTable: true,
			visibleCarrito: false,
			dashboard: true,
			historial: false,
			fast: false,
		};
	},

	computed: {
		filter2() {
			return this.$store.state.pedidos.filter;
		},
		tituloResumen() {
			return this.$route.name;
		},
		productos() {
			return this.$store.state.pedidos.productos;
		},
		total() {
			return this.$store.state.pedidos.total;
		},
		unidades() {
			return this.$store.state.pedidos.unegocio;
		},
		familia() {
			return this.$store.state.pedidos.familia;
		},
		subfamilia() {
			return this.$store.state.pedidos.subfamilia;
		},
		presentacion() {
			return this.$store.state.pedidos.presentacion;
		},
		rubro() {
			return this.$store.state.pedidos.rubro;
		},
		subrubro() {
			return this.$store.state.pedidos.subrubro;
		},
		linea() {
			return this.$store.state.pedidos.linea;
		},
		marca() {
			return this.$store.state.pedidos.marca;
		},
		loadingproducto() {
			return this.$store.state.pedidos.loadingproductos;
		},
		activeProfile() {
			return this.$store.state.perfil.activeProfile;
		},
		activeHost() {
			return this.$store.state.perfil.activeHost;
		},
		cooperativa() {
			return this.$store.state.config.cuit;
		},
	},
	filters: {
		capitalize: function (value) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
		singular: function (name) {
			return name;
			//return name.substring(name.length, name.length - 2) === 'es' ? name.substring(0, name.length - 2) : name.substring(0, name.length - 1);
		},
	},
	methods: {
		safeFirstFile(u) {
			try {
				if (!u) return null;

				if (typeof u === 'string') {
					const s = u.trim();
					if (!s) return null;
					if (s[0] === '[') {
						const arr = JSON.parse(s);
						return Array.isArray(arr) && typeof arr[0] === 'string' && arr[0].trim() ? arr[0] : null;
					}
					return s;
				}
				if (Array.isArray(u)) {
					const first = u[0];
					return typeof first === 'string' && first.trim() ? first : null;
				}

				if (typeof u === 'object') {
					if (typeof u[0] === 'string' && u[0].trim()) return u[0];
					if (typeof u.path === 'string' && u.path.trim()) return u.path;
				}
				return null;
			} catch (_) {
				return null;
			}
		},

		buildFileUrl(file) {
			const coop = encodeURIComponent(this.cooperativa);
			const arch = encodeURIComponent(file);
			return `./api/public/proxy/files?cooperativa=${coop}&type=pedidos&archivo=${arch}`;
		},

		imageSrcProd(producto) {
			const f = this.safeFirstFile(producto && producto.url);
			return f ? this.buildFileUrl(f) : '';
		},
		onChangeSearch(value, select) {
			this.start = 0;
			this.limit = 12;
			this.page = 1;
			this.syncFilterToStore();
			this.$parent.$parent.armoLLamada(this.filter, this.start, this.limit, this.page);
		},
		reset() {
			//this.$refs['filter'].resetFields();
			//TODO: ver pq no puedo hacer andar la función
			this.filter.familia_id = '';
			this.filter.subfamilia_id = '';
			this.filter.negocio_id = '';
			this.filter.presentacion_id = '';
			this.filter.rubro_id = '';
			this.filter.subrubro_id = '';
			this.filter.linea_id = '';
			this.filter.marca_id = '';
			this.filter.es_nuevo = false;
			this.filter.es_promocion = false;
			this.syncFilterToStore();
			this.callProductos();
		},
		redirect(id, producto) {
			//this.$store.dispatch('loadProducto', id);
			this.$store.dispatch('loadProductoSelected', producto);
			this.$router.push({ path: `/1/pedidos/detalle/${id}` });
		},
		setDashboard(value) {
			this.dashboard = value;
		},
		syncFilterToStore() {
			const local = this.filter || {};
			if (this._hasRealValues(local)) {
				return this.$store.dispatch('saveFilter', {
					...(this.$store.state.pedidos.filter || {}),
					...local,
				});
			}
			return Promise.resolve();
		},
		_hasRealValues(obj) {
			return Object.keys(obj || {}).some(k => {
				const v = obj[k];
				return !(v === '' || v === null || v === undefined || v === false);
			});
		},
		async fastLoad() {
			const local = this.filter || {};
			if (this._hasRealValues(local)) {
				await this.$store.dispatch('saveFilter', {
					...(this.$store.state.pedidos.filter || {}),
					...local,
				});
			}
			this.fast = true;
		},
		// displayCarrito() {
		// 	this.$store.dispatch('loadTorigen');
		// 	this.$store.dispatch('loadDentregas');
		// 	this.visibleCarrito = !this.visibleCarrito;
		// },
		// displayHistorial() {
		// 	this.$router.push(`/${this.activeProfile}/pedidos/historial`);
		// },
		goBack() {
			commit('setTotalComprados', response.data.total);
		},
		changepage(ps) {
			this.start = ps * this.limit - this.limit;
			this.page = ps;

			this.callProductos();
		},
		callProductos() {
			let filtros = this.filter2,
				start = this.start,
				limit = this.limit,
				page = this.page;
			//console.log(this.$parent.$parent.$parent);
			this.$parent.$parent.$parent.$parent.callProductos({ params: { filtros, start, limit, page } });
		},
		loadSelect(event, method) {
			this.loadingSelect = true;
			if (event) this.$store.dispatch(method, this.filter).then(asd => (this.loadingSelect = false));
		},
	},
	mounted() {
		this.$store.dispatch('loadEntitityData').then(() => {
			this.callProductos();
			this.$store.dispatch('loadCarrito');
		});
	},
};
</script>
<style lang="scss">
#pedidosproductos {
	.productos {
		display: grid;
		grid-gap: 10px;
		.producto {
			cursor: pointer;
		}
		&.grid {
			grid-template-columns: 1fr 1fr 1fr;
			.pic {
				width: 100%;
				height: 250px;
			}
			.content {
				margin-top: 10px;
			}
			.contentMobile {
				margin-top: 10px;
			}
		}
		&.row {
			.pic {
				min-width: 60px;
				width: 100px;
				height: 160px;
				vertical-align: top;
			}
			.content {
				display: inline-block;
				margin-left: 20px;
				font-size: 16px;
				line-height: 25px;
				//max-width: 250px;
			}
			.contentMobile {
				display: inline-block;
				margin-left: 20px;
				font-size: 14px;
				line-height: 25px;
				max-width: 160px;
			}
		}
		.content b {
			font-size: 20px;
		}
		.contentMobile b {
			font-size: 20px;
		}
		.pic.slot {
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #efefef;
			font-size: 12px;
		}
		.badge {
			margin-left: 5px;
		}
	}

	.header {
		background-color: var(--header-background-color);
		border-bottom: 1px solid var(--header-border-color);
		margin-bottom: 20px;
		padding-bottom: 20px;
		h6 {
			font-size: 18px;
		}
		.entidad {
			font-family: 'Open Sans', sans-serif;
			font-size: 23px;
			font-style: normal;
			font-weight: 400;
			letter-spacing: -0.25px;
			font-stretch: normal;
		}
		.el-row {
			font-size: 15px;
			font-weight: 100;
		}
		.title {
			display: block;
			opacity: 0.5;
			font-size: 12px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 1.67;
			letter-spacing: -0.2px;
		}
		.value {
			display: block;
			font-size: 25px;
			font-weight: normal;
			font-style: normal;
			font-stretch: normal;
			line-height: 0.93;
			letter-spacing: -0.5px;
		}

		.el-tabs {
			position: relative;
			top: 1px;
			.el-tabs__header {
				margin: 0;
				.el-tabs__nav {
					border: 0;
				}
			}
			.el-tabs__item {
				background-color: var(--main-color);
				color: #fff;
				&.is-active {
					background-color: #fff;
					color: var(--main-color);
				}
			}
		}
	}
}
</style>
